import { type MessageKey, t } from '../../i18n';
import type { Me } from '../../lib/auth';
import { can } from '../../lib/permissions';

// Datos de /api/inventario (guía 7.4, F2A-02): equipos con su agente y tokens de enrolamiento.

export type DeviceStatus = 'activo' | 'por_revisar' | 'retirado';
export type ReviewReason = 'serie_desconocida' | 'serie_generica' | 'cambio_organizacion' | 'hardware_duplicado';

export interface DeviceRow {
  id: string;
  hostname: string | null;
  serialNumber: string | null;
  manufacturer: string | null;
  model: string | null;
  status: DeviceStatus;
  reviewReasons: ReviewReason[];
  organizationId: string;
  organization: string | null;
  pendingOrganizationId: string | null;
  pendingOrganization: string | null;
  source: 'agente' | 'importacion';
  lastSeenAt: string | null;
  lastBootAt: string | null;
  lastInventoryAt: string | null;
  online: boolean;
  agent: { id: string; version: string; platform: string; lastHeartbeatAt: string | null; sessionUser: string | null } | null;
  can: { manage: boolean };
}

export interface TokenRow {
  id: string;
  label: string;
  hint: string;
  organizationId: string;
  organization: string | null;
  expiresAt: string;
  maxUses: number;
  uses: number;
  revokedAt: string | null;
  createdByName: string | null;
  createdAt: string;
  enrolled: number;
  state: 'vigente' | 'vencido' | 'agotado' | 'revocado';
}

export interface InventoryForm {
  organizations: Array<{ id: string; name: string; groupName: string }>;
  tokenDays: number;
}

export const canSeeInventory = (me: Me) => can(me, 'inventario.ver') || can(me, 'inventario.agentes');
export const canManageAgents = (me: Me) => can(me, 'inventario.agentes');

export const statusName = (s: DeviceStatus) => t(`inv.estado_${s}` as MessageKey);
export const reasonName = (r: ReviewReason) => t(`inv.motivo_${r}` as MessageKey);
export const platformName = (p: string) => ({ 'windows-amd64': 'Windows', 'windows-arm64': 'Windows (ARM)', 'darwin-universal': 'macOS' })[p] ?? p;

export const formatDateTime = (iso: string) => new Date(iso).toLocaleString('es-PA', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
